import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PermissionContext } from './../../../context';
import { findIndex, differenceBy } from 'lodash';
import utilities from './../../../utils/utilities';
import TableSelectBox from './../Components/TableSelectBox';
import TableRowSelect from './../Components/TableRowSelect'
import { SELECT_ALL_LIMIT } from './../../../constants';


export default function withSelectionPaginated(CollectionComponent) {
    class Selectable extends Component {
        static propTypes = {
            selectedItems: PropTypes.array,
            onSelectionChange: PropTypes.func.isRequired,
            listItems: PropTypes.array,
            actions: PropTypes.any,
            selectAllLimit: PropTypes.number,
            selectAllToggle: PropTypes.func,
            permission: PropTypes.object
        }

        static defaultProps = {
            selectedItems: [],
            actions: null,
            permission: { canEdit: true },
            selectAllLimit: SELECT_ALL_LIMIT
        }

        constructor(props) {
            super(props);
            this.toggleSelectItem = this.toggleSelectItem.bind(this);
            this.deselectAll = this.deselectAll.bind(this);
            this.areAllSelectedInPage = this.areAllSelectedInPage.bind(this);
            this.isItemSelected = this.isItemSelected.bind(this);
            this.selectAllToggle = this.selectAllToggle.bind(this);
        }

        /**
         * Unique function for selecting items behaviour
         * @param items
         */
        setSelectedItems(items) {
            this.onChange(items)
        }

        /**
         * Unique function for change event
         * @param items
         */
        onChange(items) {
            if (this.props.onSelectionChange) {
                this.props.onSelectionChange(items)
            }
        }

        /**
         * Event handler for selecting/deselecting item
         * @param item
         */
        toggleSelectItem(item) {
            let selectedItems = this.props.selectedItems;
            if (this.isItemSelected(item)) {
                selectedItems.splice(findIndex(selectedItems, (selectedItem) => selectedItem.key === item.key), 1)
            } else {
                selectedItems.push(item)
            }
            this.setSelectedItems(selectedItems)
        }

        selectAllToggle() {
            if (this.areAllSelectedInPage()) {
                this.onChange(differenceBy(this.props.selectedItems, this.props.listItems, (i) => i.key));
            } else {
                this.onChange([
                    ...this.props.selectedItems,
                    ...this.props.listItems.filter((i) => !this.isItemSelected(i))
                ]);
            }
        }

        /**
         * Deselects all items in the current page
         */
        deselectAll() {
            this.setSelectedItems([]);
        }

        /**
         * Checks if item is selected
         * @param item
         * @returns {boolean}
         */
        isItemSelected(item) {
            return this.props.selectedItems && !!this.props.selectedItems.filter(selectedItem => selectedItem.key === item.key).length
        }

        areAllSelectedInPage() {
            if (this.props.selectedItems && this.props.listItems) {
                return this.props.listItems.filter((i) => !this.isItemSelected(i)).length === 0;
            } else {
                return false;
            }
        }


        /**
         * Adds select field to the item, selection is managed internally
         * @param item
         * @returns {*}
         */
        processListItem(item) {
            const isItemSelected = this.isItemSelected(item);
            item.selected = <TableRowSelect onChange={this.toggleSelectItem} item={item} isChecked={isItemSelected}/>
            item.isSelected = isItemSelected;
            if (item.updateFunc) {
                item.updateFunc.push((prev, next) => {
                    return prev.isSelected !== next.isSelected
                });
            }
            return item
        }

        /* Header items, inject new column for selectable */
        headerItems = [{ key: "selected", label: ""}, ...this.props.headerItems];

        // temporarily add a readonly constant -- we will use context api here
        render() {
            if (this.props.permission.canEdit) {
                return <div className={"selectable-table"}>
                    <TableSelectBox items={this.props.selectedItems}
                                    format={this.props.formatSelectedItem}
                                    onDeselect={this.toggleSelectItem}
                                    onDeselectAll={this.deselectAll}
                                    selectAllToggle={this.selectAllToggle}
                                    selectedAll={this.areAllSelectedInPage()}/>
                    {this.props.actions}
                    <CollectionComponent {...this.props}
                                         listItems={this.props.listItems ? this.props.listItems.map(item => this.processListItem(item)) : null}
                                         headerItems={this.headerItems}/>
                </div>;
            } else {
                return <div className={"selectable-table readonly"}>
                    <CollectionComponent {...this.props}
                                         headerItems={this.props.headerItems.filter(item => item.key !== "actions")}/>
                </div>
            }
        }
    }

    Selectable.displayName = `Selectable(${utilities.getDisplayName(CollectionComponent)})`;
    return Selectable;
}



// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/hoc/SelectablePaginated.jsx